import React, { Component, useState, useEffect } from 'react';
import {Link} from 'react-router-dom';

import NavbarResponsive from './navbarresponsive';
//navbar und logo

function Header () {
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 10); //10px
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return ( 
        <>
            <div className={`headerContainer ${isScrolled ? "scrolled" : ""}`}>
               
                 <div className='logoHeader'>
                    <Link to="/"><img src={'/assets/img/sysmobil-logo-gross.png'} alt=''/></Link>
                </div>
                
                <div className='navigationHeader'>
                    <NavbarResponsive />
                </div>
            </div>
            
        </>
    )
}

export default Header; 